import Image from "next/image";

import { FC } from "react";

import Box, { BoxProps } from "@mui/material/Box";
import Typography, { TypographyProps } from "@mui/material/Typography";
import Container from "@mui/material/Container";

import styles from "./styles";

interface HeroProps {
  boxProps?: BoxProps;
}

const Hero: FC<HeroProps> = ({ boxProps }) => {
  return (
    <Box component="section" display="grid" sx={styles.wrapper} {...boxProps}>
      <Box sx={styles.background}>
        <Image
          src={`${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/nfcTagsPage/hero/text.png`}
          width={866}
          height={200}
          alt=""
          style={{
            objectFit: "contain",
            height: "auto",
            width: "80%",
            maxWidth: 800,
            zIndex: 20,
            position: "relative",
          }}
        />
        <Box sx={styles.tagWrapper}>
          <Image
            src={`${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/nfcTagsPage/hero/tag.png`}
            width={342}
            height={354}
            alt=""
            style={{
              objectFit: "contain",
              height: "auto",
              width: "100%",
              zIndex: 20,
              position: "relative",
            }}
          />
        </Box>
        <Image
          src={`${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/nfcTagsPage/common/grid.png`}
          width={1439}
          height={576}
          alt=""
          style={{
            width: "100%",
            height: "30vw",
            maxHeight: 200,
          }}
        />
        <Image
          src={`${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/nfcTagsPage/hero/connectors.svg`}
          width={1440}
          height={749}
          alt=""
          style={{
            width: "100%",
            position: "absolute",
            inset: 0,
            mixBlendMode: "luminosity",
            objectFit: "contain",
            objectPosition: "top",
            height: "auto",
            pointerEvents: "none",
          }}
        />
      </Box>

      <Container sx={styles.container}>
        <Text sx={{ gridColumn: 1, gridRow: 1 }} />

        <Box sx={styles.itemBox} aria-hidden="true">
          <Box sx={styles.item}>
            <Box sx={styles.shoe}>
              <Image
                src={`${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/nfcTagsPage/hero/shoe.png`}
                width={467}
                height={466}
                alt=""
                style={{ width: "100%", objectFit: "contain", height: "auto" }}
              />
            </Box>
            <Text component="p" sx={styles.strokeText} />
          </Box>
        </Box>

        <Box sx={styles.itemBox} aria-hidden="true">
          <Box sx={styles.item}>
            <Box sx={styles.tshirt}>
              <Image
                src={`${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/nfcTagsPage/hero/shirt.png`}
                width={419}
                height={465}
                alt=""
                style={{ width: "100%", objectFit: "contain", height: "auto" }}
              />
            </Box>
            <Text component="p" sx={styles.strokeText} />
          </Box>
        </Box>

        <Typography
          variant="h3"
          maxWidth={800}
          sx={{ justifySelf: "center", mt: 9, lineHeight: 1.7 }}
        >
          NFC tags are revolutionary tools designed to bring authenticity and
          digitalization to the physical products. With it, Uniqly produces
          personalized NFC tags that can be attached to any piece of clothing,
          allowing you to track all the digital fingerprints on any NFT.
        </Typography>
      </Container>
    </Box>
  );
};

interface TextProps extends TypographyProps {
  component?: keyof JSX.IntrinsicElements;
}

const Text: FC<TextProps> = ({ sx = [], component = "h1", ...props }) => {
  return (
    <Typography
      variant="h1"
      {...props}
      component={component}
      sx={[
        { fontSize: { xs: 34, md: 51, lg: 60, xl: 63 } },
        styles.text,
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      We extend user experience by blending physical and digital assets
    </Typography>
  );
};

export default Hero;
